import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../index";
import { API_BASE_URL } from "../../constants";
import { Device } from "./devicesApi";

export interface LatestData {
  timestamp: string;
  device: Device;
  temp: number;
}

const latestDataApi = createApi({
  reducerPath: "latestData",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/internaltempdata`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    }
  }),
  tagTypes: ["loadLatestTemp"],
  endpoints(builder) {
    return {
      loadLatestTempData: builder.query<LatestData[], null>({
        providesTags: users => ["loadLatestTemp"],
        query: () => {
          return {
            url: "/",
            method: "GET"
          };
        }
      })
    };
  }
});

export const { useLoadLatestTempDataQuery } = latestDataApi;
export { latestDataApi };
